// context/HeaderContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react';

// 🔹 Definimos la forma del contexto
interface HeaderContextProps {
  hideHeader: boolean;                 // Estado para saber si el header debe ocultarse
  setHideHeader: (hide: boolean) => void; // Función para cambiar el estado de ocultar el header
}

// 🔹 Creamos el contexto con valor inicial undefined
const HeaderContext = createContext<HeaderContextProps | undefined>(undefined);

// 🔹 Proveedor del contexto que envolverá la aplicación
export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [hideHeader, setHideHeader] = useState(false); // Estado inicial: header visible

  return (
    <HeaderContext.Provider value={{ hideHeader, setHideHeader }}>
      {children} {/* Renderiza los hijos envueltos con el contexto */}
    </HeaderContext.Provider>
  );
};

// 🔹 Hook personalizado para consumir el contexto fácilmente
export const useHeader = () => {
  const context = useContext(HeaderContext);

  if (!context) throw new Error("useHeader must be used within HeaderProvider");
  // ❗ Lanza error si se intenta usar fuera del proveedor
  return context;
};
